var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userSearch"},[_c('input',{staticClass:"search-box",attrs:{"placeholder":"Username / Email","type":"text"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.goToUser.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }